import $ from 'jquery';
$(document).ready(function() {
    const page = $('#news_list');

    if (page.length > 0) {
        const getUriWithParam = (baseUrl, params) => {
            const Url = new URL(baseUrl);
            const urlParams = new URLSearchParams(Url.search);
            for (const key in params) {
                if (params[key] !== undefined) {
                    urlParams.set(key, params[key]);
                }
            }
            Url.search = urlParams.toString();
            return Url.toString();
        };
        $(document).on('click', '.listArchive.pcBox > li', function(e) {
            let url = $(this).parent().data('url');
            url = getUriWithParam(url, {
                year: $(this).data('year')
            });
            window.location.href = url;
        });
        $(document).on('change', '#yearBox', function(e) {
            let url = $(this).data('url');

            if (e.target.value !== '') {
                url = getUriWithParam(url, {
                    year: e.target.value
                });
            }
            window.location.href = url;
        });
    }
});